import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Maestra',
    desc: '"El Escudo del Hogar Cristiano" (Manual Digital Completo)'
  }, {
    title: 'Mapa de Unción Paso a Paso',
    desc: 'Oraciones de amor y autoridad para cada espacio.'
  }, {
    title: 'Filtro de Santidad',
    desc: 'Guía para identificar y eliminar "estorbos" físicos en tu hogar.'
  }, {
    title: 'Devocional de 7 Días',
    desc: 'Ejercicios para hablar palabras de vida sobre tus seres queridos.'
  }, {
    title: 'Checklist de Paz Diaria',
    desc: 'Hábitos sencillos para que la presencia de Dios nunca se retire.'
  }];
  return <section className="py-20 px-6 bg-brown-900 text-cream-50" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-gold-400" data-id="element-171">
            Lo que recibirás hoy
          </h2>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-1" data-id="element-172">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-173">
                <div className="flex items-start gap-4 bg-brown-800/50 p-6 rounded-xl border border-brown-700 hover:border-gold-500/50 transition-colors" data-id="element-174">
                  <Sparkles className="w-6 h-6 text-gold-400 flex-shrink-0 mt-1" data-id="element-175" />
                  <div data-id="element-176">
                    <h3 className="text-xl font-bold text-cream-50 mb-1 font-serif" data-id="element-177">
                      {item.title}
                    </h3>
                    <p className="text-cream-100/80 text-lg" data-id="element-178">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}